import domainRegistration from './domains/domainRegistration';
import domainStack from './domains/domainStack';
import office365 from './email/office365';
import wordpress from './hosting/wordpress';
import fallback from './fallback';
import solutionSetStarter from './solution-sets/starterPlan';
import solutionSetEssentials from './solution-sets/essentialsPlan';
import solutionSetEcommerce from './solution-sets/ecommercePlan';

const list = [
  solutionSetStarter,
  solutionSetEssentials,
  solutionSetEcommerce,
  domainStack,
  domainRegistration,
  office365,
  wordpress
];

export default (item) => {
  const rules = list.find(({ match }) => match(item))?.rules;
  return rules || fallback(item);
};
